<div
  class="{{buttonClass}}"
  [ngClass]="enableReviewSelection ?  {'up': isThumbUp, 'down': isThumbDown,
                 'selected': selected, 'not-selected': !selected,
                 'basic': !raisedOnHover && !raisedOnSelected,
                 'raised-on-hover': raisedOnHover, 'raised-on-selected': raisedOnSelected} : { 'disabled':true }"
>
  <mat-icon *ngIf="isThumbUp">thumb_up</mat-icon>
  <mat-icon *ngIf="isThumbDown">thumb_down</mat-icon>
</div>
